import * as Schema from "effect/Schema";

/** Invalidation cursors, never tenant data. A fresh snapshot repairs reconnect gaps. */
export const ComplianceStreamEvent = Schema.Struct({
  organizationId: Schema.String,
  revision: Schema.String,
  type: Schema.Literals(["snapshot", "changed", "unavailable"]),
});
export type ComplianceStreamEvent = typeof ComplianceStreamEvent.Type;
